import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  themeFontSize,
  themeFontWeight,
  themeColor,
  themeFontFamily,
} from '../../util/themeLenses'

import {
  fontSize,
  fontWeight,
} from '../../util/styles'

const inputLabelColorMobile = ({ active, focus, theme, valid }) => {
    if (valid === false) {
      return themeColor('error')
    }
    if (getActive({ active, theme })) {
        if (focus) {
            return themeColor(theme.components.simpleInput.focusColor)
        }
        return themeColor('gray')
    }
    return themeColor('gray60')
}

const getActive = ({active, theme, animated}) => {
  const isAnimated = animated === undefined
    ? theme.components.simpleInput.animated
    : animated
  return !isAnimated || active
}

const fontSizeLabelSizeDesktop = ({ labelFontSize, theme }) => themeFontSize(labelFontSize || theme.components.input.labelFontSize)
const fontSizeLabelSizeMobile = ({ active, theme, labelFontSize, animated }) => getActive({active, theme, animated}) ? themeFontSize(labelFontSize) : fontSize
const inputMobileLabelColor = ({active, animated, focus, theme, valid }) => getActive({active, theme, animated}) ? inputLabelColorMobile({active, focus, theme, valid}) : 'transparent'
const inputMobileLabelTop = (props) => getActive(props) ? `calc(-12px - ${props.padding})` : `12px`

export const Label = styled.label.attrs(props => ({'data-test': props.dataTest}))`
  font-weight: ${themeFontWeight('regular')};
  font-size: ${fontSizeLabelSizeDesktop};
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 4px;
  white-space: nowrap;
  color: ${inputLabelColorMobile};
  padding-left: 8px;
  width: 100%;
  margin: 0;
  ${themeFontFamily}
  margin-top: ${inputMobileLabelTop};
  transition: margin-top 0.5s, font-size 0.5s;
  display: block;
  ${fontWeight}
  z-index: 1;
  color: ${inputMobileLabelColor};
  font-size: ${fontSizeLabelSizeMobile};
  position: absolute;
  pointer-events: none;
`

Label.propTypes = {
  focus: PropTypes.bool,
  active: PropTypes.bool,
  width: PropTypes.string,
  fontSize: PropTypes.string,
  leftIcon: PropTypes.any,
  padding: PropTypes.string,
  paddingWithIcon: PropTypes.string,
  labelFontWeight: PropTypes.string,
  labelFontSize: PropTypes.string,
  focusColor: PropTypes.string,
}

export default Label
